export default "__VITE_ASSET__Cc8ArUx2__"